import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
//  import { Link } from 'react-router-dom'
import {
  fetchMenusIfNeeded,
  selectMovie,
  fetchMovieDetailsIfNeeded,
  selectPlayVideo,
  SERVER_BASE_URL,
  CLIENT_BASE_URL
} from "../../actions";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";

import MetaTags from 'react-meta-tags';


export class VodView extends React.Component {
  constructor(props) {
    super(props);
    // CLIENT_BASE_URL = 'http://semanticvideo.net'
    this.stopVideo = this.stopVideo.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.fbShare = this.fbShare.bind(this);
    this.clickFBShare = this.clickFBShare.bind(this);
    this.ww = 0;
    this.wh = 0;
  }

  handleResize(e) {
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
  }

  componentWillMount() {
    const { match, dispatch } = this.props;
    dispatch(selectMovie(match.params.id));
  }

  componentDidMount() {
    const { match, dispatch, selectedMovie } = this.props;
    dispatch(selectMovie(match.params.id));
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    dispatch(selectPlayVideo(0));
    dispatch(fetchMovieDetailsIfNeeded(selectedMovie));
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("keydown", this.handleEscapeKey);
    this.handleResize();
    window.scrollTo(0, 0);
  }

  handleEscapeKey(e) {
    // console.log('keydown ---> ', e)
    if (e.keyCode === 27) {
      this.stopVideo();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    const { selectedMovie } = this.props;
    if (selectedMovie !== nextProps.selectedMovie) {
      dispatch(selectMovie(nextProps.match.params.id));
      dispatch(fetchMovieDetailsIfNeeded(nextProps.selectedMovie));
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.handleEscapeKey);
  }

  renderTechnicalSheet(techSheet) {
    if (techSheet !== "") {
      return (
        <div className="col-sm-offset-1 col-md-offset-3 col-sm-6 col-md-4 tech-sheet">
          <p className="text-center">FICHA TÉCNICA</p>
          <div dangerouslySetInnerHTML={{ __html: techSheet }} />
        </div>
      );
    }
  }

  getVodBackground(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  playVideo(movie_id) {
    console.log("movie_id: ", movie_id);
    const { dispatch } = this.props;
    dispatch(selectPlayVideo(movie_id));
  }

  stopVideo() {
    const { dispatch } = this.props;
    document
      .querySelectorAll(".container-fluid")[0]
      .classList.remove("fit-mode");
    dispatch(selectPlayVideo(0));
  }

  fbShare(share_url, share_title, share_text, share_image) {
    const url =
      "http://www.facebook.com/sharer.php?s=100&p[url]=" +
      encodeURIComponent(share_url) +
      "&p[images][0]=" +
      encodeURIComponent(share_image) +
      "&p[title]=" +
      encodeURIComponent(share_title) +
      "&p[summary]=" +
      encodeURIComponent(share_text);

    window.open(url, "sharer", "toolbar=0,status=0,width=626,height=436");
    return false;
  }

  renderVideoIframe() {
    console.log("renderVideoIframe", this.props);
    const { selectedPlayVideo } = this.props;
    let iframeUrl = `${SERVER_BASE_URL}/play/${selectedPlayVideo}`;
    //iframeUrl = iframeUrl.replace("https", "http");

    if (selectedPlayVideo !== 0) {
      // console.log('vou fazer o render da iframe', selectedPlayVideo)

      if (this.ww < 900) {
        return (
          <div className="popup-video" onClick={this.stopVideo}>
            <div className="iframecontainer">
              <iframe
                ref="mainIframe"
                width="100%"
                height="100%"
                src={iframeUrl}
                frameBorder="0"
                scrolling="no"
                wmode="opaque"
                allowFullScreen
              />
            </div>
          </div>
        );
      }

      let ifrmWW = 0.5 * this.ww;
      const ovr_hh = this.refs.overlay.clientHeight;
      let popup_hh = this.wh - ovr_hh;

      if (this.ww < 640) {
        ifrmWW = this.ww;
        popup_hh = this.wh;
      }

      const ifrmHH = 0.56 * ifrmWW;
      document
        .querySelectorAll(".container-fluid")[0]
        .classList.add("fit-mode");

      // vou fazer o render da iframe
      return (
        <div
          className="popup-video"
          style={{ height: popup_hh }}
          onClick={this.stopVideo}
        >
          <div
            className="iframecontainer"
            style={{ width: ifrmWW, height: ifrmHH }}
          >
            <iframe
              ref="mainIframe"
              width="100%"
              height="100%"
              src={iframeUrl}
              frameBorder="0"
              scrolling="no"
              wmode="opaque"
              allowFullScreen
            />
          </div>
        </div>
      );
    }
  }

  renderBuyButton(movie_detail) {
    // let txt = 'COMPRAR DVD'
    let txt = movie_detail.buybtn_label;
    let buyClsName = "";
    /*
    if (movie_detail.hasOwnProperty('fromfestival') &&
      movie_detail.fromfestival === '1') {
      txt = 'COMPRAR BILHETE'
      buyClsName = 'fest-buy-button'
    }

    return (
      <div className='col-sm-6 text-right'>
        <a href={movie_detail.buylink} target='_blank'><button className={buyClsName}>{txt}</button></a>
      </div>
    )
    */

    if (
      movie_detail.buybtn_label &&
      movie_detail.buybtn_label.toLowerCase().indexOf("filmin") !== -1
    ) {
      buyClsName = "buy-filmin";
    } else if (
      movie_detail.hasOwnProperty("fromfestival") &&
      movie_detail.fromfestival === "1"
    ) {
      // txt = 'COMPRAR BILHETE'
      buyClsName = "fest-buy-button";
    }

    if (!txt || txt === "") {
      return null;
    }

    return (
      <div className="col-sm-6 buy-button-wrapper text-right">
        <a href={movie_detail.buylink} target="_blank">
          <button className={buyClsName}>{txt}</button>
        </a>
      </div>
    );
  }

  toSessionText(detail) {
    return `${detail.city_name} | ${detail.dd} ${detail.mm} | ${
      detail.hhmm
    } | ${detail.venue_name}`;
  }

  renderSessionBlock(session_details) {
    if (typeof session_details !== "undefined" && session_details.length) {
      let sessionItems = [];
      session_details.map((detail, i) => {
        sessionItems.push(this.toSessionText(detail));
      });

      return (
        <div className="sessions">
          <p className="session_lbl">SESSÕES</p>
          {sessionItems.map((txt, i) => {
            return <p key={`ps${i}`}>{txt}</p>;
          })}
        </div>
      );
    }
  }

  clickFBShare() {
    const { details } = this.props;

    const share_url = `${CLIENT_BASE_URL}/filme/${details[0].id}`;
    const share_image = `${CLIENT_BASE_URL}${details[0].poster}`;
    // console.log(share_url)
    // console.log(share_image)
    this.fbShare(share_url, details[0].title, details[0].logline, share_image);
  }

  gotoPage = page => {
    this.props.history.push("/pesquisa");
  };

  render() {
    const { menus, dispatch } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const { details } = this.props;

    const movie_detail = details.length ? details[0] : {};
    // console.log('details VOD: ', details)
    var clickPlayVideo = this.playVideo.bind(this, movie_detail.id);

    let desc = "";
    if (typeof movie_detail !== "undefined" && movie_detail.description) {
      desc = movie_detail.description
        .replace(/<(?:.|\n)*?>/gm, "")
        .replace(/&nbsp;|\n|\r/gm, " ");
    }

    return (
      <div>

        <Helmet>
            <title>{movie_detail.title}</title>
            <meta property="og:title" content={movie_detail.title} />
            <meta property="og:description" content={desc} />
            <meta property="og:image" content={CLIENT_BASE_URL + movie_detail.poster} />
            <meta property="og:type" content="article" />
            <meta property="og:url" content={CLIENT_BASE_URL + "/filme/" + this.props.match.params.id} />
        </Helmet>

        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="vod">
          <div
            className="col-md-12 no-pad text-left"
            style={{ position: "relative" }}
          >
            <p className="left-tag">{movie_detail.title}</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row player-wrapper">
            <div
              className="col-md-12 poster"
              style={this.getVodBackground(movie_detail.poster)}
            >
              <div ref="overlay" className="overlay">
                <div className="row">
                  <div className="title col-sm-6">
                    <p>{movie_detail.title}</p>
                  </div>
                  {this.renderBuyButton(movie_detail)}
                </div>
                <div className="row">
                  <div className="subtitle col-sm-6">
                    <p>{movie_detail.director}</p>
                    <p>{movie_detail.keywords}</p>
                  </div>
                  <div className="summary col-sm-offset-1 col-sm-5">
                    <p>{movie_detail.logline}</p>
                  </div>
                </div>
              </div>
              {movie_detail.video_url && movie_detail.video_url !== "" ? (
                <div className="play-btn-container">
                  <div onClick={clickPlayVideo}>
                    <i className="glyphicon glyphicon-play" />
                  </div>
                </div>
              ) : null}

              {this.renderVideoIframe()}
            </div>
          </div>

          <div className="row description">
            <div className="col-sm-10">
              <div className="share">
                <p>PARTILHA</p>
                <button className="share-fb-btn" onClick={this.clickFBShare} />
                <button className="share-twitter-btn" />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-5">
                <div
                  className="desc"
                  dangerouslySetInnerHTML={{ __html: movie_detail.description }}
                />
                {this.renderSessionBlock(movie_detail.sessions)}
              </div>
              {this.renderTechnicalSheet(movie_detail.technical_info)}
            </div>
          </div>
          <FooterLinks bottom_menus={bottom_menus} />
          <FooterNote />
        </div>
      </div>
    );
  }
}

VodView.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  selectedMovie: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired,
  selectedPlayVideo: PropTypes.number.isRequired,
  selectedScope: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {
    getMenus,
    selectedMovie,
    getMovieDetails,
    selectedPlayVideo,
    selectedScope
  } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingMDetail, items: details } = getMovieDetails[
    selectedMovie
  ] || {
    isFetchingMDetail: true,
    items: []
  };

  console.log("selectedPlayVideo", selectedPlayVideo);
  typeof selectedPlayVideo === "undefined" ? 0 : selectedPlayVideo;

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingMDetail,
    details,
    selectedMovie,
    selectedPlayVideo,
    selectedScope
  };
}

export default connect(mapStateToProps)(VodView);



// WEBPACK FOOTER //
// ./src/views/VodView/VodView.js